import type { InspectionTemplate } from 'inspection-types';

import type { ReplicaStatus } from '../model/operations';

export type TemplateIdentity = {
  templateId: string;
  channelId: string;
};

export type CustomizationState = TemplateIdentity & {
  replica: InspectionTemplate | null;
  replicaStatus: ReplicaStatus;
  expandedBySectionId: Record<string, boolean>;
};

export function createInitialState(
  identity: TemplateIdentity
): CustomizationState {
  return {
    ...identity,
    replica: null,
    replicaStatus: 'loading',
    expandedBySectionId: {},
  };
}
